import { IRequestBloodHomeReview } from '@src/interfaces/blood';

export const BloodKeys = {
  reviews: ['reviews'] as const,
  home: ['home'] as const,
  bloodHomeReview: (request: IRequestBloodHomeReview) =>
    ['bloodHomeReview', request] as const,
  selectBloodHome: ['selectBloodHome'] as const,
};
